export default __webpack_public_path__ + "static/media/news.7f83a853.svg";